import {
  getFormData,
  resetFormErrors,
  resetFormValues,
  showFormErrors,
} from '../utils/form';
import {handleCaptcha, initCaptcha, resetCaptcha} from "../utils/captcha";


class ContactUs {
  constructor(section) {
    this.section = section;
    this.contactUsForm = $(".contact-us-form", this.section);
    this.idAttributePrefix = this.section.attr('id') + '-';
    this.captchaId = this.idAttributePrefix + 'captcha-container';

    this._initCaptcha();
  }

  _initCaptcha() {
    initCaptcha(() => {
      this.submitForm();
    }, this.captchaId);

    this.contactUsForm.submit(handleCaptcha(
      (e) => {
        this.submitForm();

        return false;
      }, this.captchaId
    ));
  }

  async submitForm() {
    $('.contact-us-form-success-message-container', this.section).hide();

    $('.btn-submit', this.contactUsForm).loading();
    const data = getFormData(this.contactUsForm)

    try {
      await axios.post('/api/contact_us_messages', data);

      resetFormErrors(this.contactUsForm);
      resetFormValues(this.contactUsForm, [`#${this.idAttributePrefix}v-name`,
                                                         `#${this.idAttributePrefix}v-email`,
                                                         `#${this.idAttributePrefix}v-message`]);

      $('.contact-us-form-success-message-container', this.section).show();
      $('.btn-submit', this.contactUsForm).loading(false);
    } catch (e) {
      console.log('error', e);
      $('.btn-submit', this.contactUsForm).loading(false);
      showFormErrors(this.contactUsForm, e.response);
    }

    resetCaptcha(this.captchaId);
  }
}

const initPage = () => {
  const jbSections = $('.jb-section');

  jbSections.each(function (index) {
    if (!$('.contact-us-form', this).length) {
      return;
    }

    const sectionContainer = $(this).parent();
    new ContactUs(sectionContainer)
  })
};

$(initPage);
